export default {
  reviewCompleteHeader: 'Xem l\u1ea1i v\u00e0 Ho\u00e0n t\u1ea5t',
  participants: 'Ng\u01b0\u1eddi tham gia',
  enterParticipantInfoText:
    'Vui l\u00f2ng nh\u1eadp c\u00e1c th\u00f4ng tin c\u1ea7n thi\u1ebft \u0111\u1ec3 ti\u1ebfn h\u00e0nh thanh to\u00e1n.',
  purchaser: 'Ng\u01b0\u1eddi mua',
  firstName: 'T\u00ean',
  lastName: 'H\u1ecd',
  email: 'Email',
  optionalEmail: 'Email: (t\u00f9y ch\u1ecdn)',
  'phone:': '\u0110i\u1ec7n tho\u1ea1i',
  participantFieldPlaceholder:
    'Th\u00eam m\u1edbi ho\u1eb7c ch\u1ecdn ng\u01b0\u1eddi tham gia hi\u1ec7n c\u00f3',
  reservationSummary: 'T\u00f3m t\u1eaft \u0111\u1eb7t ch\u1ed7',
  editParticipantsDetails:
    'Ch\u1ec9nh s\u1eeda th\u00f4ng tin ng\u01b0\u1eddi tham gia',
  participantDetails: 'Chi ti\u1ebft',
  duplicatePurchaserText: 'Gi\u1ed1ng ng\u01b0\u1eddi mua',
  phone: '\u0110i\u1ec7n tho\u1ea1i',
  addParticipant: 'Th\u00eam {{tierLabel}}',
  participant: 'Ng\u01b0\u1eddi tham gia',
  removeParticipant: 'X\u00f3a',
  experienceCheckoutCompleted:
    'Thanh to\u00e1n tr\u1ea3i nghi\u1ec7m ho\u00e0n t\u1ea5t',
  experienceCartCheckout:
    'Thanh to\u00e1n gi\u1ecf h\u00e0ng tr\u1ea3i nghi\u1ec7m',
  experienceLimitReached:
    'Xin l\u1ed7i, tr\u1ea3i nghi\u1ec7m n\u00e0y \u0111\u00e3 \u0111\u1ea1t s\u1ed1 l\u01b0\u1ee3ng ng\u01b0\u1eddi tham gia t\u1ed1i \u0111a',
  payment: 'Thanh to\u00e1n',
  duration: 'Th\u1eddi l\u01b0\u1ee3ng',
  discountCode: 'M\u00e3 gi\u1ea3m gi\u00e1',
  removeCode: 'X\u00f3a m\u00e3',
  invalidCodeValidation:
    'M\u00e3 gi\u1ea3m gi\u00e1 kh\u00f4ng h\u1ee3p l\u1ec7',
  networkErrorDiscountCode:
    '\u0110\u00e3 x\u1ea3y ra l\u1ed7i t\u1eeb ph\u00eda ch\u00fang t\u00f4i',
  onlyOneCouponCodeAllowed:
    'Ch\u1ec9 \u0111\u01b0\u1ee3c ph\u00e9p s\u1eed d\u1ee5ng m\u1ed9t m\u00e3 gi\u1ea3m gi\u00e1',
  creditCodeHasAlreadyBeenApplied:
    'M\u00e3 t\u00edn d\u1ee5ng \u0111\u00e3 \u0111\u01b0\u1ee3c \u00e1p d\u1ee5ng',
  discount: 'Gi\u1ea3m gi\u00e1',
  promo: 'Khuy\u1ebfn m\u00e3i',
  promoCode: 'M\u00e3 khuy\u1ebfn m\u00e3i',
  apply: '\u00c1p d\u1ee5ng',
  total: 'T\u1ed5ng c\u1ed9ng',
  subTotal: 'T\u1ea1m t\u00ednh',
  includes: 'Bao g\u1ed3m',
  and: 'v\u00e0',
  addHostNotes: 'Th\u00eam ghi ch\u00fa cho ng\u01b0\u1eddi t\u1ed5 ch\u1ee9c',
  brandAggreementText:
    'T\u00f4i \u0111\u1ed3ng \u00fd, ho\u1eb7c t\u00f4i x\u00e1c nh\u1eadn r\u1eb1ng t\u00f4i \u0111\u01b0\u1ee3c \u1ee7y quy\u1ec1n thay m\u1eb7t ng\u01b0\u1eddi tham gia \u0111\u1ed3ng \u00fd v\u1edbi c\u00e1c \u0111i\u1ec1u kho\u1ea3n v\u00e0 \u0111i\u1ec1u ki\u1ec7n c\u1ee7a',
  termsAggreementValidation:
    'Vui l\u00f2ng \u0111\u1ed3ng \u00fd v\u1edbi c\u00e1c \u0111i\u1ec1u kho\u1ea3n',
  firstNameValidation: 'T\u00ean l\u00e0 b\u1eaft bu\u1ed9c',
  lastNameValidation: 'H\u1ecd l\u00e0 b\u1eaft bu\u1ed9c',
  emailValidation: {
    emailRequiredText: 'Email l\u00e0 b\u1eaft bu\u1ed9c',
    invalidEmail: '\u0110\u1ecba ch\u1ec9 Email kh\u00f4ng h\u1ee3p l\u1ec7',
    not_specified:
      '\u0110\u1ecba ch\u1ec9 Email kh\u00f4ng ch\u00ednh x\u00e1c',
  },
  phoneValidation: {
    'Invalid Phone Number':
      'S\u1ed1 \u0111i\u1ec7n tho\u1ea1i kh\u00f4ng h\u1ee3p l\u1ec7',
    not_specified: 'Kh\u00f4ng h\u1ee3p l\u1ec7',
    phoneRequiredText:
      'S\u1ed1 \u0111i\u1ec7n tho\u1ea1i l\u00e0 b\u1eaft bu\u1ed9c',
  },
  participantFirstNameValidation:
    'T\u00ean ng\u01b0\u1eddi tham gia l\u00e0 b\u1eaft bu\u1ed9c',
  participantLastNameValidation:
    'H\u1ecd ng\u01b0\u1eddi tham gia l\u00e0 b\u1eaft bu\u1ed9c',
  complete: 'Ho\u00e0n t\u1ea5t',
  '404Message': 'Kh\u00f4ng t\u00ecm th\u1ea5y',
  waiting: '\u0110ang ch\u1edd...',
  complimentary: 'Mi\u1ec5n ph\u00ed',
  confirmationHeader:
    'Tr\u1ea3i nghi\u1ec7m c\u1ee7a b\u1ea1n \u0111\u00e3 \u0111\u01b0\u1ee3c \u0111\u1eb7t!',
  confirmationText:
    'Email x\u00e1c nh\u1eadn \u0111\u00e3 \u0111\u01b0\u1ee3c g\u1eedi \u0111\u1ebfn {{email}} v\u1edbi th\u00f4ng tin chi ti\u1ebft',
  viewAll: 'Xem t\u1ea5t c\u1ea3 tr\u1ea3i nghi\u1ec7m',
  paymentMethod: 'Ph\u01b0\u01a1ng th\u1ee9c thanh to\u00e1n',
  creditCard: 'Th\u1ebb t\u00edn d\u1ee5ng',
  roomCharge: 'T\u00ednh v\u00e0o ph\u00f2ng',
  memberCharge: 'T\u00ednh v\u00e0o th\u00e0nh vi\u00ean',
  roomOrReservationNumber:
    'S\u1ed1 ph\u00f2ng ho\u1eb7c S\u1ed1 x\u00e1c nh\u1eadn',
  roomNumber: 'S\u1ed1 ph\u00f2ng',
  roomNumberLegacy: 'S\u1ed1 ph\u00f2ng / M\u00e3 x\u00e1c nh\u1eadn',
  memberNumber: 'S\u1ed1 th\u00e0nh vi\u00ean',
  kicc: 'KICC',
  chargeValidation:
    'S\u1ed1 ph\u00f2ng v\u00e0 H\u1ecd l\u00e0 b\u1eaft bu\u1ed9c',
  memberNumberValidation:
    'S\u1ed1 th\u00e0nh vi\u00ean l\u00e0 b\u1eaft bu\u1ed9c',
  invalidRoomNumber: 'S\u1ed1 ph\u00f2ng kh\u00f4ng h\u1ee3p l\u1ec7',
  invalidRoomNumberLegacy:
    'S\u1ed1 ph\u00f2ng ho\u1eb7c m\u00e3 x\u00e1c nh\u1eadn kh\u00f4ng h\u1ee3p l\u1ec7',
  invalidMemberNumber:
    'S\u1ed1 th\u00e0nh vi\u00ean kh\u00f4ng h\u1ee3p l\u1ec7',
  invalidPhoneNumber:
    'S\u1ed1 \u0111i\u1ec7n tho\u1ea1i kh\u00f4ng h\u1ee3p l\u1ec7',
  requiredPhoneNumber:
    'S\u1ed1 \u0111i\u1ec7n tho\u1ea1i l\u00e0 b\u1eaft bu\u1ed9c',
  guestNameIsRequired: 'T\u00ean kh\u00e1ch l\u00e0 b\u1eaft bu\u1ed9c',
  roomNumberIsRequired: 'S\u1ed1 ph\u00f2ng l\u00e0 b\u1eaft bu\u1ed9c',
  roomNumberIsRequiredLegacy:
    'S\u1ed1 ph\u00f2ng ho\u1eb7c M\u00e3 x\u00e1c nh\u1eadn l\u00e0 b\u1eaft bu\u1ed9c',
  roomOrReservationNumberIsRequired:
    'S\u1ed1 ph\u00f2ng ho\u1eb7c s\u1ed1 x\u00e1c nh\u1eadn l\u00e0 b\u1eaft bu\u1ed9c',
  cardNumberIncomplete: 'S\u1ed1 th\u1ebb ch\u01b0a \u0111\u1ea7y \u0111\u1ee7',
  lastNameValidationError: 'H\u1ecd l\u00e0 b\u1eaft bu\u1ed9c',
  isReqd: 'l\u00e0 b\u1eaft bu\u1ed9c',
  reservationCode: 'S\u1ed1 \u0111\u1eb7t ch\u1ed7/X\u00e1c nh\u1eadn',
  nonHotelGuest: 'Kh\u00e1ch ngo\u00e0i kh\u00e1ch s\u1ea1n',
  onPropertyGuest: 'Kh\u00e1ch \u0111ang l\u01b0u tr\u00fa',
  preArrivalGuest: 'Kh\u00e1ch ch\u01b0a \u0111\u1ebfn',
  cardNumber: 'S\u1ed1 th\u1ebb',
  pmsValidationErrorMessage:
    'H\u1ecd ho\u1eb7c s\u1ed1 ph\u00f2ng ho\u1eb7c s\u1ed1 x\u00e1c nh\u1eadn kh\u00f4ng h\u1ee3p l\u1ec7',
  pmsDateValidationErrorMessage:
    'Xin l\u1ed7i! Ng\u00e0y tr\u1ea3i nghi\u1ec7m kh\u00f4ng n\u1eb1m trong kho\u1ea3ng th\u1eddi gian l\u01b0u tr\u00fa c\u1ee7a b\u1ea1n.',
  fullName: 'H\u1ecd v\u00e0 t\u00ean',
  checkout: 'Thanh to\u00e1n',
  editParticipants: 'Ch\u1ec9nh s\u1eeda ng\u01b0\u1eddi tham gia',
  private: 'Ri\u00eang t\u01b0',
  browseAllExperieces: 'Xem t\u1ea5t c\u1ea3 tr\u1ea3i nghi\u1ec7m',
  payWithCreditCard: 'Thanh to\u00e1n b\u1eb1ng Th\u1ebb t\u00edn d\u1ee5ng',
  payWithRoomCharge: 'T\u00ednh v\u00e0o ph\u00f2ng',
  payWithMemberCharge: 'T\u00ednh v\u00e0o th\u00e0nh vi\u00ean',
  payWith: 'Thanh to\u00e1n b\u1eb1ng',
  bookBulkErrorByCard:
    '\u0110\u00e3 x\u1ea3y ra s\u1ef1 c\u1ed1 khi x\u00e1c nh\u1eadn \u0111\u1eb7t ch\u1ed7. Th\u1ebb c\u1ee7a b\u1ea1n ch\u01b0a b\u1ecb t\u00ednh ph\u00ed.',
  bookBulkErrorByRoomCharge:
    'H\u1ecd v\u00e0 s\u1ed1 ph\u00f2ng kh\u00f4ng h\u1ee3p l\u1ec7.',
  bookBulkErrorByMemberCharge:
    'H\u1ecd v\u00e0 s\u1ed1 th\u00e0nh vi\u00ean kh\u00f4ng h\u1ee3p l\u1ec7.',
  reviewCancellation: 'Xem l\u1ea1i h\u1ee7y',
  selectAReservationToCancel:
    'Ch\u1ecdn m\u1ed9t \u0111\u1eb7t ch\u1ed7 \u0111\u1ec3 h\u1ee7y',
  confirmCancellation: 'X\u00e1c nh\u1eadn h\u1ee7y',
  cancellable: 'C\u00f3 th\u1ec3 h\u1ee7y',
  cancelled: '\u0110\u00e3 h\u1ee7y',
  deadlinePassed: '\u0110\u00e3 qu\u00e1 h\u1ea1n',
  noCancellations: 'Kh\u00f4ng c\u00f3 h\u1ee7y',
  reviewReschedule: '\u0110\u1eb7t ch\u1ed7 c\u1ee7a b\u1ea1n',
  selectAReservationToReschedule:
    'Ch\u1ecdn m\u1ed9t \u0111\u1eb7t ch\u1ed7 \u0111\u1ec3 \u0111\u1ed5i l\u1ecbch',
  confirmReservation: 'X\u00e1c nh\u1eadn \u0111\u1eb7t ch\u1ed7',
  confirm: 'X\u00e1c nh\u1eadn',
  selectADateAndTime: 'Ch\u1ecdn ng\u00e0y v\u00e0 gi\u1edd',
  noOtherSessionsAvailableForThisExperience:
    'Kh\u00f4ng c\u00f3 phi\u00ean n\u00e0o kh\u00e1c cho tr\u1ea3i nghi\u1ec7m n\u00e0y.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    '\u0110\u1eb7t ch\u1ed7 n\u00e0y kh\u00f4ng th\u1ec3 \u0111\u1ed5i l\u1ecbch \u0111\u01b0\u1ee3c n\u1eefa. Vui l\u00f2ng g\u1eedi email \u0111\u1ebfn {{brandEmail}}',
  thisReservationCannotBeRescheduled:
    '\u0110\u1eb7t ch\u1ed7 n\u00e0y kh\u00f4ng th\u1ec3 \u0111\u1ed5i l\u1ecbch',
  noTimesAvailable: 'Kh\u00f4ng c\u00f3 gi\u1edd tr\u1ed1ng',
  noBookingsAvailable: 'Kh\u00f4ng c\u00f3 \u0111\u1eb7t ch\u1ed7 tr\u1ed1ng',
  youPaid: 'B\u1ea1n \u0111\u00e3 thanh to\u00e1n',
  refund: 'Ho\u00e0n ti\u1ec1n',
  yourRefund: 'Ho\u00e0n ti\u1ec1n c\u1ee7a b\u1ea1n',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Ho\u00e0n ti\u1ec1n s\u1ebd \u0111\u01b0\u1ee3c x\u1eed l\u00fd v\u1ec1 ph\u01b0\u01a1ng th\u1ee9c thanh to\u00e1n ban \u0111\u1ea7u.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    '\u0110\u1eb7t ch\u1ed7 n\u00e0y kh\u00f4ng th\u1ec3 h\u1ee7y \u0111\u01b0\u1ee3c n\u1eefa. Vui l\u00f2ng g\u1eedi email \u0111\u1ebfn {{brandEmail}}',
  reservationCancelled: '\u0110\u1eb7t ch\u1ed7 \u0111\u00e3 h\u1ee7y',
  thisReservationCannotBeCancelled:
    '\u0110\u1eb7t ch\u1ed7 n\u00e0y kh\u00f4ng th\u1ec3 h\u1ee7y',
  thisReservationHasAlreadyBeenCancelled:
    '\u0110\u1eb7t ch\u1ed7 n\u00e0y \u0111\u00e3 \u0111\u01b0\u1ee3c h\u1ee7y',
  theHotel: 'Kh\u00e1ch s\u1ea1n',
  cancelling: '\u0110ang h\u1ee7y',
  somethingWentWrong: '\u0110\u00e3 x\u1ea3y ra l\u1ed7i',
  previouslyRefunded:
    '\u0110\u00e3 ho\u00e0n ti\u1ec1n tr\u01b0\u1edbc \u0111\u00f3',
  remainingBalance: 'S\u1ed1 d\u01b0 c\u00f2n l\u1ea1i',
  notEnoughPoints: 'Kh\u00f4ng \u0111\u1ee7 \u0111i\u1ec3m',
  notEnoughPointsDescription:
    'B\u1ea1n kh\u00f4ng c\u00f3 \u0111\u1ee7 \u0111i\u1ec3m World of Hyatt \u0111\u1ec3 ho\u00e0n t\u1ea5t giao d\u1ecbch n\u00e0y.',
  currentPointsBalance:
    'S\u1ed1 d\u01b0 \u0111i\u1ec3m hi\u1ec7n t\u1ea1i: {{count, number}}',
  points: '\u0111i\u1ec3m',
  pointsWithCount_one: '{{count, number}} \u0111i\u1ec3m',
  pointsWithCount_other: '{{count, number}} \u0111i\u1ec3m',
  payWithHyattPoints: 'Thanh to\u00e1n b\u1eb1ng \u0111i\u1ec3m Hyatt',
  pleaseSignIn: 'Vui l\u00f2ng \u0111\u0103ng nh\u1eadp',
  worldOfHyattPoints: '\u0110i\u1ec3m World of Hyatt',
  bookBulkErrorByNotEnoughSeats:
    'Kh\u00f4ng \u0111\u1ee7 ch\u1ed7 cho phi\u00ean n\u00e0y. Vui l\u00f2ng th\u1eed phi\u00ean kh\u00e1c.',
  phoneNumber: 'S\u1ed1 \u0111i\u1ec7n tho\u1ea1i',
  requestToBookConfirmationText:
    'Email x\u00e1c nh\u1eadn \u0111\u00e3 \u0111\u01b0\u1ee3c g\u1eedi \u0111\u1ebfn {{email}}',
  reservationRescheduled:
    '\u0110\u1eb7t ch\u1ed7 \u0111\u00e3 \u0111\u01b0\u1ee3c \u0111\u1ed5i l\u1ecbch',
  yourReservationWasRescheduledTo:
    '\u0110\u1eb7t ch\u1ed7 c\u1ee7a b\u1ea1n \u0111\u00e3 \u0111\u01b0\u1ee3c \u0111\u1ed5i sang',
  viewExperiences: 'Xem tr\u1ea3i nghi\u1ec7m',
  joinBook: 'Tham gia & \u0110\u1eb7t',
  signInBook: '\u0110\u0103ng nh\u1eadp & \u0110\u1eb7t',
  signAndJoin:
    '\u0110\u0103ng nh\u1eadp ho\u1eb7c Tham gia \u0111\u1ec3 \u0110\u1eb7t',
  signAndJoinDescription:
    'Tr\u1ea3i nghi\u1ec7m World of Hyatt FIND ch\u1ec9 d\u00e0nh ri\u00eang cho th\u00e0nh vi\u00ean World of Hyatt. \u0110\u0103ng nh\u1eadp ho\u1eb7c tham gia \u0111\u1ec3 \u0111\u1eb7t v\u00e0 t\u00edch \u0111i\u1ec3m. Kh\u00f4ng mu\u1ed1n tham gia? B\u1ea1n v\u1eabn c\u00f3 th\u1ec3 \u0111\u1eb7t c\u00e1c tr\u1ea3i nghi\u1ec7m kh\u00f4ng \u0111\u1ed9c quy\u1ec1n b\u1eb1ng c\u00e1ch x\u00f3a Tr\u1ea3i nghi\u1ec7m World of Hyatt kh\u1ecfi gi\u1ecf h\u00e0ng.',
  promoOrFind:
    'M\u00e3 khuy\u1ebfn m\u00e3i ho\u1eb7c M\u00e3 t\u00edn d\u1ee5ng Find',
  hyattTermsAndConditions:
    '\u0110i\u1ec1u kho\u1ea3n & \u0110i\u1ec1u ki\u1ec7n',
  hyattTermsAndConditionsAgreement:
    'B\u1eb1ng vi\u1ec7c x\u00e1c nh\u1eadn \u0111\u1eb7t ch\u1ed7 n\u00e0y, t\u00f4i ch\u1ea5p nh\u1eadn ch\u00ednh s\u00e1ch h\u1ee7y. T\u00f4i c\u0169ng \u0111\u00e3 \u0111\u1ecdc v\u00e0 x\u00e1c nh\u1eadn vi\u1ec7c s\u1eed d\u1ee5ng th\u00f4ng tin c\u00e1 nh\u00e2n c\u1ee7a t\u00f4i theo',
  hyattTermsAndConditionsLink: 'Ch\u00ednh s\u00e1ch B\u1ea3o m\u1eadt Hyatt',
  hyattWaiverText:
    'B\u1eb1ng vi\u1ec7c mua tr\u1ea3i nghi\u1ec7m n\u00e0y, t\u00f4i \u0111\u1ed3ng \u00fd, hi\u1ec3u v\u00e0 x\u00e1c nh\u1eadn, c\u1ea3 thay m\u1eb7t b\u1ea3n th\u00e2n v\u00e0 thay m\u1eb7t b\u1ea5t k\u1ef3 c\u00e1 nh\u00e2n n\u00e0o tham gia tr\u1ea3i nghi\u1ec7m do t\u00f4i mua (n\u1ebfu c\u00f3), v\u1edbi nh\u1eefng \u0111i\u1ec1u sau',
  hyattWaiverLink: 'mi\u1ec5n tr\u1eeb chung',
  priceDisclaimer: 'Bao g\u1ed3m ph\u00ed tr\u01b0\u1edbc thu\u1ebf',
  curatedRecommendations:
    'G\u1ee3i \u00fd \u0111\u01b0\u1ee3c tuy\u1ec3n ch\u1ecdn',
  moreExperiencesYouMightLike:
    'Nh\u1eefng tr\u1ea3i nghi\u1ec7m kh\u00e1c b\u1ea1n c\u00f3 th\u1ec3 th\u00edch',
  similarExperiencesAvailableToBookDirectly:
    'Trải nghiệm tương tự có thể đặt trực tiếp',
  experiencesAvailableAroundYourBookingDate:
    'C\u00e1c tr\u1ea3i nghi\u1ec7m c\u00f3 s\u1eb5n quanh ng\u00e0y \u0111\u1eb7t c\u1ee7a b\u1ea1n',
  confirmationEmailSent:
    'Ch\u00fang t\u00f4i \u0111\u00e3 g\u1eedi x\u00e1c nh\u1eadn \u0111\u1ebfn {{email}} v\u1edbi th\u00eam chi ti\u1ebft.',
  youreBooked: 'B\u1ea1n \u0111\u00e3 \u0111\u1eb7t th\u00e0nh c\u00f4ng',
  purchaserInformation: 'Th\u00f4ng tin ng\u01b0\u1eddi mua',
  requiredFieldIndicator:
    '* bi\u1ec3u th\u1ecb tr\u01b0\u1eddng b\u1eaft bu\u1ed9c',
  resourceSelectionTitle: 'Chọn tùy chọn của bạn',
  resourceSelectionDescription:
    'Chọn một tùy chọn cho từng mục trong đặt chỗ của bạn.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Chọn {{attributeName}}',
  resourceValueSoldOut: '{{label}} (đã hết)',
  resourceValueUnavailableWith: '{{label}} (không có sẵn với {{picks}})',
  resourceOptionsUnavailable:
    'Không thể tải các tùy chọn cho khung giờ này. Vui lòng thử lại.',
  resourceOptionsRetry: 'Thử lại',
  changeResourceSelections: 'Thay đổi lựa chọn của bạn',
};
